import { useAuthStore } from '@/modules/auth/presentation/store/auth.store';
import { useProfile } from '@/modules/profile/presentation/hooks/use-profile';

/**
 * Página inicial do admin-dashboard. Substitui a antiga home ("Dados Pessoais"),
 * que migrou para o user-dashboard. Por ora é uma visão geral de boas-vindas;
 * pode receber widgets/atalhos conforme a necessidade.
 */
export function HomePage() {
  const { auth } = useAuthStore();
  const { data: profile } = useProfile();

  const firstName =
    profile?.name?.split(' ')[0] ?? auth?.email?.split('@')[0] ?? 'Usuário';

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-(--color-text-primary) text-2xl font-bold">
          Bem-vindo, {firstName}
        </h1>
        <p className="text-(--color-text-secondary) mt-1 text-sm">
          Painel administrativo Primum.
        </p>
      </div>

      <div className="border-(--color-border) bg-(--color-bg-primary) rounded-xl border p-6 shadow-sm">
        <p className="text-(--color-text-secondary) text-sm">
          Use o menu lateral para acessar os módulos de gerenciamento. Para
          gerenciar seus dados pessoais e segurança da conta, abra o menu do seu
          avatar e escolha <strong>Minha Conta</strong>.
        </p>
      </div>
    </div>
  );
}
